import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var InitialsSvg = function InitialsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.423 4.749 2 5.231l3.67 11.2h2.082l3.671-11.2L10 4.75 6.712 14.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.522 4.749h2.956L22 16.049l-1.365.486-.956-3.065h-5.358l-.956 3.065L12 16.05zm1.919 1.54L19.2 11.93h-4.4l1.76-5.643z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 18.224v1.525H2v-1.525zM11.05 15.173h-1.5v1.525h1.5z"
  }));
};
export var Initials = function Initials(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: InitialsSvg
  }));
};